export default __webpack_public_path__ + "static/media/color_logo.2677cd98.png";